import React from 'react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Nu am crezut niciodată că pot descoperi atât de multe la mine. Credeam că voi îmbătrâni fără să știu ce m-a făcut nefericită și că nu voi scăpa de amintirea traumelor. Astăzi am o relație frumoasă cu mama, un job care mă bucură, un partener și îmi pun în sfârșit talentele în aplicare.',
    name: 'Georgiana'
  }, {
    quote: 'Mulțumesc din suflet, doamnă Simona. Nu am crezut că voi fi un alt om după această dezvoltare personală. Am înțeles atâtea lucruri de care nu aveam habar. Am reușit să am un comportament sănătos față de soțul meu și să construim o familie fericită, departe de traumele din copilărie.',
    name: 'Geny'
  }];
  return <section className="bg-white py-24 md:py-32" data-id="element-195">
      <div className="max-w-[1180px] mx-auto px-6" data-id="element-196">
        <div className="max-w-4xl mx-auto space-y-12" data-id="element-197">
          {/* Header */}
          <div className="text-center" data-id="element-198">
            <h2 className="font-serif text-4xl md:text-5xl font-medium text-cyan" data-id="element-199">
              Ce spun femeile care au lucrat cu mine
            </h2>
          </div>

          {/* Large decorative quote mark */}
          <div className="text-center" data-id="element-200">
            <span className="font-serif text-8xl md:text-9xl text-magenta opacity-20 leading-none" data-id="element-201">
              "
            </span>
          </div>

          {/* Testimonials */}
          <div className="grid md:grid-cols-2 gap-8" data-id="element-202">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-2xl border border-cardBorder p-8 space-y-6" data-id="element-203">
                <p className="text-lg leading-relaxed text-navy italic" data-id="element-204">
                  „{testimonial.quote}"
                </p>
                <p className="text-xs font-medium tracking-widest uppercase text-muted" data-id="element-205">
                  — {testimonial.name}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}